module.exports = __webpack_public_path__ + "static/media/ic_recursive_billing_setup.467b007e.svg";